var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        left: "",
        origin: "right top",
        "z-index": "99",
        "content-class": "notification-dropdown",
        transition: "slide-y-transition",
        "nudge-top": "-10",
        "close-on-content-click": false
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function fn(_ref) {
            var on = _ref.on
            return [
              _c(
                "v-badge",
                {
                  attrs: {
                    color: "red",
                    overlap: "",
                    value: _vm.notifications.length
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "badge",
                        fn: function fn() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "pos-relative"
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.notificationsCount) + " "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "visually-hidden"
                                  },
                                  [_vm._v("notifications")]
                                )
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        attrs: {
                          icon: ""
                        }
                      },
                      on
                    ),
                    [
                      _c("v-icon", [_vm._v("mdi-bell")]),
                      _c(
                        "span",
                        {
                          staticClass: "visually-hidden text-lowercase"
                        },
                        [_vm._v("Notifications")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.opened,
        callback: function callback($$v) {
          _vm.opened = $$v
        },
        expression: "opened"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "dropdown-content"
        },
        [
          _c("v-progress-linear", {
            attrs: {
              absolute: "",
              active: _vm.loading,
              indeterminate: ""
            }
          }),
          _vm.notifications.length
            ? _c(
                "div",
                {
                  staticClass: "notifications-area"
                },
                [
                  _c("dismiss-all", {
                    attrs: {
                      location: "header"
                    },
                    on: {
                      update: _vm.updateData
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-list"
                    },
                    [
                      _c(
                        "ul",
                        _vm._l(_vm.notifications, function(item) {
                          return _c(
                            "li",
                            {
                              key: item.id
                            },
                            [
                              _c("notification-item", {
                                attrs: {
                                  item: item
                                },
                                on: {
                                  visit: _vm.visitNotification,
                                  dismiss: _vm.dismissNotification
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  ),
                  _c("view-all-notifications", {
                    on: {
                      close: function close($event) {
                        _vm.opened = false
                      }
                    }
                  })
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "notifications-area-empty"
                },
                [
                  _c("no-notifications"),
                  _c("view-all-notifications", {
                    on: {
                      close: function close($event) {
                        _vm.opened = false
                      }
                    }
                  })
                ],
                1
              )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }